/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Price_OverlineInputs */

const en_mk_price_overline = /** @type {(inputs: Mk_Price_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PRICING`)
};

const id_mk_price_overline = /** @type {(inputs: Mk_Price_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HARGA`)
};

/**
* | output |
* | --- |
* | "PRICING" |
*
* @param {Mk_Price_OverlineInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_price_overline = /** @type {((inputs?: Mk_Price_OverlineInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Price_OverlineInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_price_overline(inputs)
	return en_mk_price_overline(inputs)
});